<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Troca de senha</h1>

        <form @submit.prevent="submit">
          <h3>{{ $store.state.nome }}</h3>
          <h4>{{ $store.state.documento }}</h4>

          <!-- <fieldset>
            <input type="password" required placeholder="Senha atual">
          </fieldset> -->

          <fieldset>
            <input type="password" required placeholder="Nova senha" v-model="model.novaSenha">
          </fieldset>

          <fieldset>
            <input type="password" required placeholder="Repita a nova senha" v-model="model.novaSenhaConfirmacao">
          </fieldset>

          <fieldset class="submit">
            <button type="submit">Salvar</button>
          </fieldset> <!-- /.submit -->

          <transition name="fade" mode="out-in">
            <h6 class="aligncenter" v-if="showMessage">{{ errorMsg || 'Senha alterada com sucesso!' }}</h6>
          </transition>
        </form> <!-- /form -->
      </div> <!-- /.container -->
    </section> <!-- /.form -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'troca-senha',

  data () {
    const data = {
      loading: false,
      showMessage: false,
      errorMsg: '',

      model: {
        codigoUsuario: '',
        senhaAtual: '',
        novaSenha: '',
        novaSenhaConfirmacao: ''
      }
    }

    return data
  }, // data()

  mounted () {
    this.model.codigoUsuario = this.$store.state.codigoUsuario
    this.model.nomeCliente = this.$store.state.nome
    this.model.cpfCliente = this.$store.state.documento
  }, // mounted()

  methods: {
    async submit () {
      if (this.loading) return

      this.errorMsg = ''
      this.loading = true
      this.showMessage = false

      if (this.model.novaSenha !== this.model.novaSenhaConfirmacao) { this.errorMsg = 'As novas senhas não conferem.' }

      if (this.errorMsg) this.showMessage = true
      if (this.showMessage) return this.loading = false

      try {
        let xhr = await PagesService.trocaSenha(this.model)

        this.errorMsg = ''
      } catch (e) {
        console.error('Falha ao enviar mensagem', e)
        this.errorMsg = 'Falha ao realizar a troca de senha.'
      }

      this.loading = false
      this.showMessage = true

      setTimeout(() => {
        this.showMessage = false
      }, 4000)
    } // envia()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section.form form
    input, textarea
      background-color: map-get($colors, bg_body) !important

    h3, h4, h6
      color: #919191 !important

    .submit
      display: flex
      justify-content: center

      button
        width: 255px
        height: 45px
        padding: 0
        margin-left: 20px
        font-weight: 700
        font-size: 22px

  @media (max-width: 767px)
    section.form
      form
        h3
          font-size: 20px

        h4
          color: #000 !important
          font-weight: 700

        input
          font-size: 13px !important

        .submit
          button
            width: 100%
            margin-left: 0 !important
            font-size: 18px !important
</style>
